import React, { useState } from 'react';
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons';
import { Collapse, darken, makeStyles, Theme, Typography } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    border: '3px solid',
    borderColor: darken('#FFF', 0.16),
    backgroundColor: '#E0E3EA',
  },
  content: {
    backgroundColor: 'white',
  },
}));

interface ContentWrapperProps {
  title: string;
  children: JSX.Element;
  collapsed?: boolean;
  /**
   * `dataTestId` - name of a content wrapper (preferably `<name>-content-wrapper`)
   * @example
   * ```tsx
   * <ContentWrapper {...props} dataTestId="test-content-wrapper">
   *  {children}
   * </ContentWrapper>
   */
  dataTestId?: string;
}

export const ContentWrapper: React.FC<ContentWrapperProps> = ({ title, children, collapsed = false, dataTestId }) => {
  const classes = useStyles();

  const [show, setShow] = useState(!collapsed);

  return (
    <div className={`flex flex-col mx-0.5 mb-3 ${classes.wrapper} rounded-lg`}>
      <div
        className={`flex flex-row justify-between py-1 px-2 items-center cursor-pointer `}
        onClick={() => setShow((prev) => !prev)}
        data-testid={`${dataTestId}-header`}
      >
        <Typography style={{ fontSize: 18 }} data-testid={`${dataTestId}-title`}>
          {title}:
        </Typography>
        <div>{show ? <ArrowDropUp /> : <ArrowDropDown />}</div>
      </div>
      <Collapse className="px-2 rounded-b-md bg-white" in={show}>
        {children}
      </Collapse>
    </div>
  );
};
